// TODO: deprecate this file
import Renderer from 'Renderer'

export const getRenderer = () => Renderer.getInstance()

export default getRenderer
